import type { TFunction } from 'i18next';
import { array, bool, boolean, number, string } from 'yup';

import { OnboardingSignupTypes } from 'src/shared/graphql/generated';

export const makeName = (t: TFunction) =>
  string()
    .required(t('onboarding.pleaseProvideName'))
    .min(2, t('onboarding.nameMustBeAtLeast'))
    .max(255, t('onboarding.nameTooLong')); // https://github.com/hoverinc/hyperion/blob/7e6672c38d1d32893e228416c411f4dbcc9849f4/db/schema.rb#L1969

const PersonaTypes = [
  OnboardingSignupTypes.Construction,
  OnboardingSignupTypes.Homeowner,
] as const;

export const makePersona = () => string().oneOf(PersonaTypes).required();

export const OrgTypes = [
  OnboardingSignupTypes.Construction,
  OnboardingSignupTypes.Insurance,
] as const;

export const makeOrg = () => string().oneOf(OrgTypes).required();

export const makeEmail = (t: TFunction) =>
  string()
    .required(t('onboarding.emailIsRequired'))
    .email(t('onboarding.pleaseEnterAValidEmail'))
    .matches(
      /^[^@\s]+@((?:[-a-z0-9]+\.)+[a-z]{2,})$/i,
      t('onboarding.pleaseEnterAValidEmail'),
    );

export enum OrgConstructionDescriptions {
  NEW_CONSTRUCTION = 'new construction',
  ARCHITECT_DESIGNER = 'architect / designer',
  ROOFING = 'roofing',
  SIDING = 'siding',
  WINDOWS_AND_DOORS = 'windows & doors',
  DISTRIBUTOR_MANUFACTURER = 'Distributor / Manufacturer',
  INTERIOR_TRADES = 'Interior Trades',
}

export enum OrgInsuranceDescriptions {
  CARRIER = 'carrier',
  CLAIMS_ADJUSTING_FIRM = 'claims adjusting firm',
  INDEPENDENT_ADJUSTER = 'independent adjuster',
  INSPECTION_FIRM = 'inspection firm',
  INDEPENDENT_INSPECTOR = 'independent inspector',
}

const validDescriptions = [
  ...Object.values(OrgConstructionDescriptions),
  ...Object.values(OrgInsuranceDescriptions),
];

export const makeOrgDescriptions = () =>
  array().required().of(string().required().oneOf(validDescriptions));

export const makeCustomDescription = () => string();

export const makeOrgUsageMin = () => number().positive().integer();
export const makeOrgUsageMax = () => number().positive().integer();

export const makeOrgName = (t: TFunction) =>
  string().required(t('onboarding.pleaseProvideName'));

export const makeEnableSMS = () => boolean().required();

export const makeInviteEmail = (t: TFunction) =>
  string().email(t('onboarding.pleaseEnterAValidEmail'));

export const makeAgreeToTerms = (t: TFunction) =>
  bool().oneOf([true], t('onboarding.agreeToTermsIsRequired'));
